<div class="column">
    <h2>Rettocolite ulcerosa - Pazienti stabili e instabili per malattia iniziale attiva/inattiva</h2>
    <h3>L'analisi è stata effettuata considerando i pazienti che hanno compilato il questionario SCCAI.</h3>
    <h3>Cut-off: 5.</h3>
    <div style="display: inline-block" style = "padding-left: 3vw; padding-top: 0vw; position: center">
      <div class = "chart-container" [ngStyle]="{'cursor': isHovered ? 'pointer' : ''}">
        <canvas id = "myChartStableUnstableUCInitialActiveInactivePathology"></canvas>
      </div>
    </div>
  </div>